module.exports = __webpack_public_path__ + "img/vector-shape4.3f535f93.png";